import { getInstance } from "../instance";
import { CatalogBook, MemberBooksResponse } from "./types";

/**
 * ABO-managed member books. The endpoints are versioned (`/v1/...`), so we use
 * RELATIVE paths on the shared `dsInstance` whose baseURL already carries `/v1`
 * (same pattern as `api/memberAccount/actions.ts`).
 */
const instance = getInstance();

/** The full book catalog for the picker (active books by default). */
export const getBookCatalog = async (): Promise<CatalogBook[]> => {
  return instance
    .get<CatalogBook[]>("/book-catalog")
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};

/** A member's current books, resolved to names. */
export const getMemberBooks = async (
  customerId: string
): Promise<MemberBooksResponse> => {
  return instance
    .get<MemberBooksResponse>(`/abo/customers/${customerId}/books`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};

/** Adds books to the member (DS-only). Unknown codes are rejected by DS (422). */
export const addMemberBooks = async (
  customerId: string,
  codes: string[]
): Promise<void> => {
  return instance
    .post(`/abo/customers/${customerId}/books`, { codes })
    .then(() => undefined)
    .catch((error) => Promise.reject(error));
};

/** Removes books from the member (DS-only). Takes effect on the next login. */
export const removeMemberBooks = async (
  customerId: string,
  codes: string[]
): Promise<void> => {
  return instance
    .delete(`/abo/customers/${customerId}/books`, { data: { codes } })
    .then(() => undefined)
    .catch((error) => Promise.reject(error));
};
